<div class="input-group">
    <button
        class="btn stepper-btn"
        type="button"
        [disabled]="!canDecrement()"
        [attr.aria-label]="ariaLabel() + ' decrease'"
        (click)="decrement()"
    >
        -
    </button>
    <input
        class="form-control input-md number-stepper-field"
        type="number"
        [value]="value() ?? ''"
        [disabled]="disabled()"
        [readOnly]="readonly()"
        [required]="required()"
        [step]="step()"
        [attr.min]="min()"
        [attr.max]="max()"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-invalid]="isInvalid()"
        [class.is-valid]="isValid()"
        [class.is-invalid]="isInvalid()"
        (input)="onInput($event)"
        (blur)="touched.set(true)"
    />
    <button
        class="btn stepper-btn"
        type="button"
        [disabled]="!canIncrement()"
        [attr.aria-label]="ariaLabel() + ' increase'"
        (click)="increment()"
    >
        +
    </button>
</div>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
